import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../Icons'

const RequestIntegrationModal = ({ onClose, onSubmit, isLoading, isRequestSent }) => {
  const { t } = useTranslation(['integrations', 'common'])
  const [formData, setFormData] = useState({
    integrationName: '',
    additionalComments: '',
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!formData.integrationName.trim()) {
      return
    }

    await onSubmit({
      type: 'integration-request',
      ...formData,
    })
  }

  const handleClose = () => {
    if (isRequestSent) {
      setFormData({ integrationName: '', additionalComments: '' })
    }
    onClose()
  }

  if (isRequestSent) {
    return (
      <div className="integration-modal-overlay" onClick={handleClose}>
        <div
          className="integration-modal request-integration-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="integration-modal__header">
            <h2>{t('integrations:requestModal.title')}</h2>
            <button className="integration-modal__close" onClick={handleClose}>
              <Icon icon="cross" width="24" height="24" />
            </button>
          </div>
          <div className="integration-modal__body">
            <div className="request-sent-content">
              <div className="request-sent-icon">
                <Icon icon="checkmark" width="40" height="40" viewBox="0 0 30 30" />
              </div>
              <h3>{t('integrations:shared.requestSentTitle')}</h3>
              <p>{t('integrations:requestModal.requestSentBody')}</p>
              <button className="button button-primary" onClick={handleClose}>
                {t('common:actions.close')}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="integration-modal-overlay" onClick={onClose}>
      <div
        className="integration-modal request-integration-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="integration-modal__header">
          <h2>{t('integrations:requestModal.title')}</h2>
          <button className="integration-modal__close" onClick={onClose}>
            <Icon icon="cross" width="24" height="24" />
          </button>
        </div>
        <div className="integration-modal__body">
          <div className="request-integration-content">
            <p className="request-integration-description">
              {t('integrations:requestModal.description')}
            </p>
            <hr className="request-integration-divider" />
            <form onSubmit={handleSubmit} className="request-integration-form">
              <div className="form-group">
                <label htmlFor="integrationName" className="form-label">
                  {t('integrations:requestModal.nameLabel')}
                </label>
                <input
                  type="text"
                  id="integrationName"
                  name="integrationName"
                  value={formData.integrationName}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder={t('integrations:requestModal.namePlaceholder')}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="additionalComments" className="form-label">
                  {t('integrations:requestModal.additionalCommentsLabel')}
                </label>
                <textarea
                  id="additionalComments"
                  name="additionalComments"
                  value={formData.additionalComments}
                  onChange={handleInputChange}
                  className="form-textarea"
                  placeholder={t('integrations:requestModal.additionalCommentsPlaceholder')}
                  rows={5}
                />
              </div>
              <div className="form-actions">
                <button
                  type="button"
                  className="button button-secondary"
                  onClick={onClose}
                  disabled={isLoading}
                >
                  {t('common:actions.cancel')}
                </button>
                <button
                  type="submit"
                  className={`button button-primary ${isLoading ? 'is-loading' : ''}`}
                  disabled={isLoading || !formData.integrationName.trim()}
                >
                  {isLoading
                    ? t('integrations:requestModal.sendingButton')
                    : t('integrations:requestModal.sendButton')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

RequestIntegrationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isRequestSent: PropTypes.bool,
}

export default RequestIntegrationModal
